import { CSSProperties, FC } from 'react';
import { Stack } from 'rsuite';
import { SvgIconProps } from '@material-ui/core';
import { TextColor } from '../../../enums';
import {
  MetricIconButton,
  MetricCardWrapper,
  MetricValueWrapper,
  MetricCardsContainer
} from './styled';
import SText from '../../sui/stext';

// ! TYPES
// export outside component for other components
export interface MetricCardPanelItem {
  title: string;
  Icon: FC<SvgIconProps>;
  iconColor: CSSProperties['color'];
  metric: {
    amount: number;
    currency: string;
    annotation?: {
      text: string;
      color: CSSProperties['color'];
    };
  };
}

interface MetricCardsPanelProps {
  cardsData: MetricCardPanelItem[];
}

// ! COMPONENT
export const MetricCardsPanel = ({ cardsData }: MetricCardsPanelProps) => (
  <MetricCardsContainer>
    {cardsData?.map((cardItem, index) => (
      <MetricCardWrapper key={`${index + 1}`}>
        <Stack direction="row" alignItems="center" spacing={8}>
          <MetricIconButton size="small">
            <cardItem.Icon fill={cardItem.iconColor} />
          </MetricIconButton>

          <SText fontColor={TextColor.SlateGrey} weight="semibold" maxLines={2}>
            {cardItem.title}
          </SText>
        </Stack>

        <MetricValueWrapper>
          <SText weight="semibold" size="xl">
            {cardItem.metric.amount.toLocaleString('en-US', {
              currency: cardItem.metric.currency,
              style: 'currency',
              minimumFractionDigits: 0
            })}
          </SText>

          {cardItem.metric.annotation && (
            <SText
              size="xs"
              weight="semibold"
              lineHeight="20px"
              fontColor={cardItem.metric.annotation.color}>
              {cardItem.metric.annotation.text}
            </SText>
          )}
        </MetricValueWrapper>
      </MetricCardWrapper>
    ))}
  </MetricCardsContainer>
);
